module.exports = __webpack_public_path__ + "img/meeting-summary.634b9c67.webp";